import {createContext, Dispatch, useContext} from "react";
import {AuthAction, AuthState} from "../reducer/LoginReducer";

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);

//Pour gérer le cas du undefined
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

interface AuthContextProps {
    state: AuthState;
    dispatch: Dispatch<AuthAction>;
}
